import styled from '@emotion/styled';
import theme from '@vromo/ui/components/theme';
import Color from 'color';

export const CurrencyPicker = styled.div`
    align-items: center;
    background-color: ${theme.lightGrey};
    border: 1px solid ${theme.lightGrey};
    border-radius: 3px;
    display: flex;
    margin-left: 3px;
    padding: 8px;
`;


interface AddButtonProps {
    theme?: typeof theme; // Adjust the type if necessary
    ['data-testid']?:string;
  }
  
  export const AddButton = styled.button<AddButtonProps>`
    background-color: transparent;
    border: none;
    border-radius: 4px;
    color: ${theme.primary};
    padding: 10px;
    transition: all 200ms ease-in-out;
    &:hover,
    &:focus {
        color: ${Color(theme.primary).darken(0.2).toString()};
        background-color: ${Color(theme.primary).lighten(0.5).toString()};
    }
    &[data-testid] {
        data-testid: ${(props) => props['data-testid']};
      }
  `;

export const FormWithLabelMargins = styled.form`
    label {
        margin-top: 10px;
    }
`;

export default {
    container: {
        display: 'flex',
        flexDirection: 'column'
    },
    inputDivider: {
        width: '10px'
    },
    smsCheckboxLabel: {
        fontWeight: 'bold'
    },
    orderValueButton: {
        marginBottom: '5px',
        marginLeft: '10px'
    },
    optedInForCampaignSmsDescription: {
        marginBottom: '20px',
        whiteSpace: 'pre-wrap'
    },
    itemList: {
        flex: 1
    },
    dropOffInputLabelDivider: {
        marginTop: 5
    },
    instructionsContainer: {
        maxWidth: '100%'
    },
    instructionsInput: {
        minHeight: 100,
        resize: 'vertical'
    }
};
